var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconDelete = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.566,
    height: 15.6,
    viewBox: "0 0 13.566 15.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1241",
    "data-name": "Group 1241",
    transform: "translate(0.3 0.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924",
    transform: "translate(0.742 2.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M982.641,870.14l-.468,10.884a.933.933,0,0,1-.936.868h-8.165a.934.934,0,0,1-.936-.868l-.468-10.884a.128.128,0,0,0-.255.01l.468,10.884a1.185,1.185,0,0,0,1.19,1.1h8.165a1.184,1.184,0,0,0,1.19-1.1l.468-10.884a.128.128,0,0,0-.255-.01Z",
    transform: "translate(-971.414 -870.022)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925",
    transform: "translate(6.359 4.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M987.724,874.593V883a.124.124,0,1,0,.247,0v-8.408a.124.124,0,0,0-.247,0Z",
    transform: "translate(-987.724 -874.469)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926",
    transform: "translate(3.563 4.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M979.569,874.6l.248,8.408a.124.124,0,1,0,.247-.007l-.248-8.408a.124.124,0,0,0-.247.007Z",
    transform: "translate(-979.569 -874.47)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927",
    transform: "translate(8.908 4.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M995.385,874.59,995.138,883a.124.124,0,1,0,.247.007l.248-8.408a.124.124,0,0,0-.247-.007Z",
    transform: "translate(-995.138 -874.47)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928",
    transform: "translate(0 1.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M969.317,866.562h12.712a.124.124,0,1,0,0-.247H969.317a.124.124,0,1,0,0,.247Z",
    transform: "translate(-969.19 -866.314)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929",
    transform: "translate(3.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M980.566,864.013l.265-.662a.864.864,0,0,1,.733-.5h2.72a.861.861,0,0,1,.734.5l.264.662.23-.092-.265-.661a1.106,1.106,0,0,0-.963-.653h-2.72a1.111,1.111,0,0,0-.963.653l-.265.661Z",
    transform: "translate(-980.337 -862.607)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 0.6
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_delete.53ea2869.svg";
export { ForwardRef as ReactComponent };